var $ = require('jquery');
var _ = require('underscore');
var Authentication = require('Authentication');
var Authorization = require('Authorization');
var Consultation = require('Consultation');
var Labels = require('Labels');
var Lookups = require('Lookups');
var Redbox = require('Redbox');
var API = EY.Consultation.Lookups.API;
var Azure = EY.Consultation.Lookups.Azure;
var URL_LENGTH = 1024;

// Backbone functionality overridden to work with the data-layer!
var backbone = function () {
    _.extend(Backbone.Collection.prototype, {
        // Adapts the Backbone.Collection's sync/read(fetch) API to work with MongoApiController/MongoDataContext.
        // Usage/Expectation:
        // Pass filter, select, sort, page and rows as an options-hash to Backbone.Collection.fetch(options) e.g.
        //  options: {
        //    filter: {
        //        _id: 1//parentId: { $gt: 1  } 
        //    },
        //    select: {
        //        text: 1
        //    },
        //    sort: {
        //        _id: 1
        //    },
        //    page: 1,
        //    rows: 20
        //  }
        sync: function (method, collection, options) {
            var deferred = $.Deferred();
            var promise = '';

            if (method === 'read') {
                var url = collection.url.replace(/\/Aggregate\/|\/AggregateViaPost\/|\/GetViaPost\//g, '/');
                var host = url.replace(/[a-zA-Z]*$/, '');
                collection.url = url;
                options = options || {};
                options.data = options.data || {};
                _.extend(options.data, {
                    filter: JSON.stringify(options.filter || {}),
                    select: JSON.stringify(options.select || {}),
                    sort: JSON.stringify(options.sort || {}),
                    page: options.page || 1,
                    rows: options.rows || 0
                });
                if (options.data.filter.length > URL_LENGTH) {
                    collection.url = collection.url.replace(host, host + 'GetViaPost/');
                } else if (!_.isEmpty(options.aggregate)) {
                    options.data.aggregate = JSON.stringify(options.aggregate);
                    collection.url = collection.url.replace(host, host + (options.data.aggregate.length > URL_LENGTH ? 'AggregateViaPost/' : 'Aggregate/'));
                }
                if ((options.data.filter.length > URL_LENGTH) || (!_.isEmpty(options.aggregate) && options.data.aggregate.length > URL_LENGTH)) {
                    var post = new Backbone.Model();

                    options.error && post.on('error', options.error);
                    promise = deferred.promise();
                    _.extend(post, { urlRoot: collection.url }).set(options.data).save().done(function (data) {
                        if (_.isArray(data)) {
                            _.each(data, function (response) {
                                if (!response.id && response._id) {
                                    response.id = _.isObject(response._id) ? response._id.$oid : response._id;
                                }
                            });
                        }
                        collection.reset(data);
                        collection.trigger('sync');
                        collection.trigger('synced');
                        deferred.resolve(data);
                    }).catch(() => {
                        deferred.resolve([]);
                    });
                }
            }
            return promise || Backbone.sync.apply(this, arguments);
        }
    });
    _.extend(Backbone.Model.prototype, {
        // Overridden because setting Backbone.Model.idAttribute doesn't seamlessly handle 'id' => '_id' mapping.
        // Particularly when underscore library functions are used i.e. indexBy.
        // Additionally, this keeps the usage of id field status-quo wihtout burdening the consumer with the knowledge if _id vs id.
        // The benefits of this approach outweigh the obvious redundancy.
        parse: function (response) {
            if (response && !response.id && response._id) {
                response.id = _.isObject(response._id) ? response._id.$oid : response._id;
            }
            return response;
        },
        // MongoApiController/MongoDataContext offer generic/schema-less interface to the MongoDB.
        // Convention: this override ensures that sync/save(create/update) will only send Backbone.Model.default hash, to the server.
        // Usage/Expectation: only the attributes defined in the Backbone.Model.default hash to be synced with the server, for example:
        //  Backbone.Model.extend({
        //    defaults: {
        //        'clientName': '',
        //        'statusId': 2
        //    }
        //  })
        sync: function (method, model) {
            var defaults = model.defaults;
            var upn = EY.Consultation.CurrentUser ? EY.Consultation.CurrentUser.upn : '';

            // MongoDB: introduce Auditable fields, iff they are needed!
            if ((method === 'create' || method === 'update') && !_.isEmpty(defaults)) {
                model.attributes = _.pick(model.attributes, _.union([model.idAttribute], _.keys(defaults)));
                model.set({
                    modifiedBy: upn,
                    modifiedOn: new Date()
                });

                if (method === 'create') {
                    model.set({
                        createdBy: upn,
                        createdOn: new Date()
                    });
                }
            }
            return Backbone.sync.apply(this, arguments);
        }
    });
};

var log = function (message, args) {
    var logger = new Backbone.Model();

    try {
        args = args || arguments;
        _.extend(logger, { urlRoot: API.Consultation + EY.Consultation.Lookups.Configuration.ApplicationLogCollection }).set({
            message: message,
            timestamp: new Date()
        }).save().done(function () {
            console.log('Logged to server!', args);
        });
    } catch (e) {
        console.log('Error logging message to server!', e);
    }
};

// Application level overrides for jquery Ajax-Setup.
var jquery = function () {
    $.ajaxPrefilter(function (options, originalOptions, jqXHR) {
        if (window.location.origin.indexOf(options.url) == -1) {
            options.crossDomain = true;
            // Bearer token will be different for graph API and Other APIs
            // As per new changes, the two tokens are received based on different scopes.
            // Azure.GraphUrl contains token for User.Read and Azure.Token contains token
            // for api access (using user_impersonation scope).
            var isGraphUrl = options.url.indexOf(EY.Consultation.Lookups.Azure.GraphUrl) == 0;
            var token = isGraphUrl ? Azure.GraphToken : Azure.Token;
            jqXHR.setRequestHeader('authorization', 'bearer ' +  token); // setting the bearer token

            // TODO: --SQ Needs to be moved to UserLookup and/or wherever Azure.GraphUrl is being used to avoid jquery cache-busting query-string from being passed along!
            if (isGraphUrl) {
                options.cache = true;
            }
        }
    });
    $.ajaxSetup({
        cache: false
    });
    $(document).ajaxError(function (event, request, settings, error) {
        // It use to log error repeatedly, hence removed it.
        if (EY.Consultation.Lookups.Configuration.ShowErrorPage) {
            if (request.status === 401) {
                window.location = 'Consultation/NotAuthorized?culture=' + EY.Consultation.CurrentCulture;
            }
        }
    });
    $.fn.isInViewport = function () {
        var elementTop = $(this).offset().top;
        var elementBottom = $('#header').outerHeight() + elementTop + $(this).outerHeight();
        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();

        return elementTop >= 0 && elementBottom < viewportBottom && elementBottom > viewportTop;
    };
};

// Application level overrides for javascript.
var js = function () {
    var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    _.extend(Date.prototype, {
        format: function () {
            return ('0' + this.getDate()).slice(-2) + ' ' + months[this.getMonth()] + ' ' + this.getFullYear();
        },
        addDays: function (days) {
            var d = new Date(this.valueOf());
            d.setDate(d.getDate() + days);
            return d;
        },
        isoDate: function () {
            return _.first(this.toISOString().split('T'));
        },
        //https://stackoverflow.com/questions/11526504/minimum-and-maximum-date
        minDate: function() {
            return new Date(-8640000000000000);
        },
        maxDate: function() {
            return new Date(8640000000000000);
        }
    });
};

// IE 
function ie() {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    if (msie > 0 || !!ua.match(/Trident.*rv\:11\./)) {
        EY.Consultation.Lookups.Configuration.BrowserIE = true;
    }
}

// Template setting to use {{ instead of '<%'!
var underscore = function () {
    _.templateSettings = {
        evaluate: /\{\{-(.+?)\}\}/g,
        interpolate: /\{\{=(.+?)\}\}/g,
        escape: /\{\{([^=].+?)\}\}/g
    };
};

// Configure services/overrides...
$(function () {
    if (window.location.href.indexOf('#') === -1) {
        window.location = window.location.origin + '/#';
    }
    require('bootstrap');
    require('bootstrap-datepicker');
    jquery();
    EY.Consultation.Lookups.IsHandHeldDevice = navigator.userAgent.match(/Android/i) || 
    navigator.userAgent.match(/BlackBerry/i) ||
    navigator.userAgent.match(/iPhone|iPad|iPod/i) ||
    navigator.userAgent.match(/Opera Mini/i) ||
    navigator.userAgent.match(/IEMobile/i);
    // For debugging purposes uncomment and add your name/spn.
    //var upn = "abc.def@ghi.com".toLowerCase();
    //var user = new Backbone.Model();
    //_.extend(user, { urlRoot: API.Consultation + 'User' }).set({ id: upn }).fetch({ async: false }).done(function () {
    //    EY.Consultation.CurrentUser = { givenName: "abc def", location: { country: '' }, model: user, upn: upn };
    //});
    // When debugging with above name/spn, comment authentication.
    backbone();
    Authentication.configure().done(function () {
        js();
        underscore();
        Labels.configure().done(function () {
            Authorization.configure();
            Lookups.configure().done(function () {
                Redbox.configure();
                Consultation.start();
                ie();
                log(JSON.stringify({ browser: window.navigator && window.navigator.userAgent, login: _.pick(EY.Consultation.CurrentUser, ['upn', 'geography', 'preferences', 'roles']) }));
            });
        });
    });
});

// Window Error catch-all
window.addEventListener('error', function (e) {
    var message = e.error ? e.error.toString() : e.message;
    var stack = e.error && e.error.stack ? e.error.stack : '';

    log(JSON.stringify({
        browser: window.navigator && window.navigator.userAgent,
        error: stack ? message + '\n' + stack : message,
        user: EY && EY.Consultation && EY.Consultation.CurrentUser && EY.Consultation.CurrentUser.upn
    }));
    return true;
});

window.addEventListener("dragover", function (e) {
    e = e || event;
    e.preventDefault();
}, false);

window.addEventListener("drop", function (e) {
    e = e || event;
    e.preventDefault();
}, false);


// WEBPACK FOOTER //
// ./js/setup.js